import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { kubernetesTranslationRef } from '@backstage/plugin-kubernetes/alpha';
import { kubernetesReactTranslationRef } from '@backstage/plugin-kubernetes-react/alpha';
import { kubernetesPtBr, kubernetesReactPtBr } from './kubernetes-ptbr';
import { TranslationBlueprint } from '@backstage/plugin-app-react';


export const kubernetesTranslations: any = TranslationBlueprint.make({
    name: 'kubernetes-pt-BR',

    params: {
        resource: createTranslationResource({
            ref: kubernetesTranslationRef,
            translations: {
                'pt-BR': async () => ({ default: kubernetesPtBr })
            },
        }),
    },
});

export const kubernetesReactTranslations: any = TranslationBlueprint.make({
    name: 'kubernetes-react-pt-BR',

    params: {
        resource: createTranslationResource({
            ref: kubernetesReactTranslationRef,
            translations: {
        'pt-BR': async () => ({ default: kubernetesReactPtBr })
            },
        }),
    },
});